import { Component, PropsWithChildren, ReactNode } from "react"

import Button from "../../libs/ui/buttons/Button"

export interface PaginationProps {
    maxPagges: number
    actualPage: number
    updateActualPageCallBack: Function
    manageExpiredSessionsCallBack: Function
}

interface PaginationState {
    pages: number[]
}

class Pagination extends Component<PropsWithChildren<PaginationProps>, PaginationState> {

    constructor (props: any) {
        super(props)

        let allPages = []
        for (var i = 1; i <= this.props.maxPagges; i++) {
            allPages.push(i)
        }

        this.state = {
            pages: allPages
        }

        this.changePage = this.changePage.bind(this)
    }

    render(): ReactNode {
        const actualPage = Number(this.props.actualPage)

        return (
            <>
                <div className="row">
                    <div id="navigation" className="col-12 paginationButtonContainer">
                        { Number(this.props.maxPagges) > 0 && this.state.pages && 
                            <>
                                { this.state.pages.map( (p) => {
                                    const buttonClass= "navButtom " + (actualPage === p ? " actual" : "")
                                    const mainKey = p + '_' + actualPage

                                    return  <span key={'span_' + p}>
                                                { (Number(p) < actualPage)
                                                    ?   <Button 
                                                            id={p.toString()}
                                                            type="button"
                                                            key={'btn_' + mainKey}
                                                            className="completeStepButton"
                                                            onClick={this.changePage}
                                                        >
                                                            ✓
                                                        </Button>
                                                    :   <Button 
                                                            id={p.toString()}
                                                            type="button"
                                                            key={'btn_' + mainKey}
                                                            className={ buttonClass }
                                                            onClick={this.changePage}
                                                        >
                                                            {p}
                                                        </Button>
                                                }
                                                { Number(p) < Number(this.props.maxPagges) &&
                                                    <img 
                                                        key={'img_' + p}
                                                        src="https://www.6sicuro.it/wp-content/uploads/2024/12/step-preventivatore-long-arrow.svg" 
                                                        alt="prossimo step img"
                                                    />
                                                }
                                            </span>
                                    }
                                )}
                            </>
                        }
                    </div>

                    <>
                        {this.props.children}
                    </>
                </div>
            </>
        )
    }

    private changePage (e: any) {
        const nextPageNumber = parseInt( e.target.id )

        if (nextPageNumber < this.props.actualPage) {
            this.props.updateActualPageCallBack( nextPageNumber )
        }
    }
}

export default Pagination